// extracted by mini-css-extract-plugin
export default {"companyContainer":"mP-z","companyImage":"nP-z","container":"oP-z","heading":"pP-z","darkText":"qP-z","smallHeading":"rP-z","darkBackground":"sP-z","whiteBackground":"tP-z"};